export default __webpack_public_path__ + "static/media/accountManager.82d9176d.svg";